import { getGuessStatuses } from './statuses'

export const shareStatus = (guesses: string[]) => {
  const today = new Date();
  navigator.clipboard.writeText(
    `Valyrian Wordle ${today.toLocaleDateString()} ${guesses.length}/6\n\n` +
      generateEmojiGrid(guesses)
  )
}

export const generateEmojiGrid = (guesses: string[]) => {
  return guesses
    .map((guess) => {
      const status = getGuessStatuses(guess)
      return guess
        .split('')
        .map((letter, i) => {
          switch (status[i]) {
            case 'correct':
              return '🟩'
            case 'present':
              return '🟨'
            default:
              return '⬜'
          }
        })
        .join('')
    })
    .join('\n')
}
